export const parallelEditTypes = {
  EDIT_TO_EDIT: 0,
  CREATE_TO_EDIT: 1,
  EDIT_TO_CREATE: 2,
  CREATE_TO_CREATE: 3,
};
